import React, { useState, useEffect } from "react";
import { Route, Routes, Link, NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './pics/logo.png';
import ContactNew from './pages/ContactNew.js';
import AddActivity from "./pages/AddActivity.js";
import ActivityMapNew from "./pages/ActivityMapNew.js";
import ActivitiesNew from "./pages/ActivitiesNew.js";
import ActivityDetail from "./pages/ActivityDetail.js";
import DonateNew from "./pages/DonateNew.js";
import DonationManagement from "./pages/DonationManagement.js";
import DonationList from "./pages/DonationList.js";
import Login from "./components/Login.js";
import Breadcrumb from "./components/Breadcrumb.js";
import { auth, db } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import './app2.css';
import './styles/newDesign.css';



function App() {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        // ทุกคนที่ login ได้เป็น admin อัตโนมัติ
        setIsAdmin(true);
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setCheckingAuth(false);
    });

    return () => unsubscribe();
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      closeMobileMenu();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div>
      {/* Modern Navbar */}
      <nav className={`modern-navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container-modern">
          <div className="navbar-container">
            {/* Logo/Brand */}
            <Link to="/activity-map" className="navbar-brand" onClick={closeMobileMenu}>
              <img
                src={logo}
                alt="ศูนย์แบ่งต่อ มูลนิธิกระจกเงา"
                className="navbar-logo"
              />
            </Link>

            {/* Mobile Menu Toggle */}
            <button 
              className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>

            {/* Navigation Links */}
            <div className={`nav-links-container ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <div className="nav-links-wrapper">
                <NavLink 
                  to="/activity-map" 
                  className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  {t('nav.home')}
                </NavLink>
                <NavLink 
                  to="/activities" 
                  className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  {t('nav.activities')}
                </NavLink>
              <NavLink 
                to="/donate" 
                className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                {t('nav.donate')}
              </NavLink>
              <NavLink 
                to="/contact" 
                className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                {t('nav.contact')}
              </NavLink>
              {isAdmin && (
                <NavLink 
                  to="/add-activity" 
                  className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  {t('nav.addActivity')}
                </NavLink>
              )}
              <NavLink 
                to="/donors" 
                className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                {t('nav.donors')}
              </NavLink>
              {isAdmin && (
                <NavLink 
                  to="/donations-management" 
                  className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  {t('nav.manageDonations')}
                </NavLink>
              )}
              </div>

            {/* Auth Section */}
            <div className="auth-section" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginLeft: '20px' }}>
              {currentUser ? (
                <>
                  <span style={{ color: '#fff', fontSize: '14px' }}>
                    {currentUser.email}
                  </span>
                  <button
                    className="modern-nav-link"
                    onClick={handleLogout}
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '8px 16px' }}
                  >
                    {t('nav.logout') || 'ออกจากระบบ'}
                  </button>
                </>
              ) : (
                <NavLink 
                  to="/login" 
                  className={({ isActive }) => `modern-nav-link ${isActive ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  {t('nav.login') || 'เข้าสู่ระบบ'}
                </NavLink>
              )}
            </div>

            {/* Language Switcher */}
            <div className="lang-switcher">
              <button
                className={`lang-btn ${i18n.language === 'th' ? 'active' : ''}`}
                onClick={() => changeLanguage('th')}
              >
                ไทย
              </button>
              <button
                className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                onClick={() => changeLanguage('en')}
              >
                EN
              </button>
            </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="App">
        <div className="container-modern" style={{ paddingTop: '100px' }}>
          <Breadcrumb />
        </div>
        <Routes>
          <Route path="/" element={<ActivityMapNew />} />
          <Route path="/activity-map" element={<ActivityMapNew />} />
          <Route path="/contact" element={<ContactNew />} />
          <Route path="/activities" element={<ActivitiesNew />} />
          <Route path="/donate" element={<DonateNew />} />
          <Route path="/login" element={<Login />} />
          <Route path="/add-activity" element={<AddActivity />} />
          <Route path="/activity/:name" element={<ActivityDetail />} />
          <Route path="/donations-management" element={<DonationManagement />} />
          <Route path="/donors" element={<DonationList />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;